import type { FieldValues, FormState } from "react-hook-form"

export const isFormSubmitDisabled = (formState: FormState<FieldValues>) => {
  const { isValid, errors } = formState

  return Object.keys(errors).length > 0 || !isValid || formState.isSubmitting
}
